import { Annotation, AnnotationSet, PdfPage } from '@paragon/contract-library';

import { SealingService } from '../connections';

interface PdfPageWithAnnotationSet extends PdfPage {
  readonly annotationSet: AnnotationSet;
}

export function fetch(id: number): Promise<PdfPageWithAnnotationSet> {
  return SealingService.get(`pdfPages/${id}`);
}

export function createBlankPage(pdfId: number, insertPosition: number): Promise<PdfPage> {
  return SealingService.post(`pdfPages`, {
    params: new URLSearchParams({ positionToInsertAt: insertPosition.toString() }),
    data: { PdfId: pdfId },
  });
}

export function updateAnnotations(id: number, annotations: readonly Annotation[]) {
  return SealingService.post(`pdfPages/${id}/annotations`, {
    data: {
      id,
      annotationSet: {
        annotations,
      },
    },
  });
}

export function createAnnotationSet(annotations: readonly Annotation[]): Promise<AnnotationSet> {
  return SealingService.post('pdfPages/createAnnotationSet', { data: annotations });
}

export function migrateAnnotationSet(annotationSet: AnnotationSet): Promise<AnnotationSet> {
  return SealingService.post('pdfPages/migrateAnnotationSet', { data: annotationSet });
}

export function reset(id: number) {
  return SealingService.post(`pdfPages/${id}/reset`);
}

export function remove(id: number) {
  return SealingService.delete(`pdfPages/${id}`);
}
